// Minimal non-invasive cart badge refresher
// Add to theme assets and include with: <script src="{{ 'cart-badge-refresh.js' | asset_url }}" defer></script>

(function () {
  // Selectors for the cart count badge in your header.
  // If your header uses a different selector, change/add it here.
  var BADGE_SELECTORS = [
    '.custom-header__cart-count', // selector used in the header you posted
    '[data-cart-count]'           // optional fallback if you add it later
  ];

  var DEBOUNCE_MS = 250;
  var debounceTimer = null;

  function getBadgeNodes() {
    var nodes = [];
    BADGE_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) {
        if (nodes.indexOf(n) === -1) nodes.push(n);
      });
    });
    return nodes;
  }

  function setBadgeCount(count) {
    var nodes = getBadgeNodes();
    if (!nodes.length) return;
    nodes.forEach(function (node) {
      node.textContent = String(count || 0);
      node.setAttribute('data-cart-count', String(count || 0));
      node.setAttribute('aria-live', 'polite');
      node.setAttribute('aria-atomic', 'true');
    });
  }

  function fetchCartAndUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then(function (cart) {
          var count = (cart && typeof cart.item_count !== 'undefined') ? cart.item_count : null;
          if (count !== null) setBadgeCount(count);
          document.dispatchEvent(new CustomEvent('cart:badge-updated', { detail: { count: count, cart: cart } }));
        })
        .catch(function (err) {
          console.warn('cart-badge-refresh: failed to fetch cart.js', err);
        });
    }, DEBOUNCE_MS);
  }

  // React to your sticky bar and other possible emitters
  document.addEventListener('cart:item-added', fetchCartAndUpdate);
  document.addEventListener('cart:updated', fetchCartAndUpdate);

  // Detect when cart-drawer is inserted/replaced (your code replaces this node)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = false;
      mutations.some(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (!node) continue;
            if (node.nodeType === 1 && node.tagName && node.tagName.toLowerCase() === 'cart-drawer') {
              shouldRefresh = true;
              return true;
            }
            if (node.querySelector && node.querySelector('cart-drawer')) {
              shouldRefresh = true;
              return true;
            }
          }
        }
        if (mutation.target && mutation.target.nodeType === 1 && mutation.target.tagName && mutation.target.tagName.toLowerCase() === 'cart-drawer') {
          shouldRefresh = true;
          return true;
        }
      });
      if (shouldRefresh) fetchCartAndUpdate();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // Run once on load to ensure correct initial count
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  } else {
    fetchCartAndUpdate();
  }

  // Expose for manual refresh if you want
  window.theme = window.theme || {};
  window.theme.refreshCartBadge = fetchCartAndUpdate;
})();